import { Warning } from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { Button } from "../../Atoms/Button";
import {
  DialogBox,
  Header,
  DialogContainer,
  InformationContainer,
} from "./styles";

export const BalanceWarning = ({
  open,
  onClose,
  currentBalance,
  transactionValue,
}) => {
  const history = useHistory();

  return (
    <DialogContainer open={open} onClose={onClose}>
      <DialogBox>
        <Header>
          <p>
            <Warning />
            Saldo insuficiente para realizar a transação
          </p>
        </Header>
        <InformationContainer>
          <p>
            Seu saldo atual é de <span>{currentBalance}</span>
          </p>
          <p>
            Para concluir a transação recarregue ao menos{" "}
            <span>{transactionValue}</span>
          </p>
          <div>
            <Button
              style={{ width: 250, height: 45, fontSize: 18 }}
              onClick={() => {
                history.push({
                  pathname: "/tickets",
                  search: "newTicket=true",
                });
              }}
            >
              Recarregar
            </Button>
          </div>
        </InformationContainer>
      </DialogBox>
    </DialogContainer>
  );
};
